import useHovered from '../hooks/useHovered';

const HoverProvider = props => {
  return props.children(useHovered(props));
};

HoverProvider.displayName = 'HoverProvider';
export default HoverProvider;